/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Select_Folder_TitleInputs */

const en_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Video - Select Folder`)
};

const fr_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la video - Selectionner un dossier`)
};

const de_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video exportieren – Ordner auswählen`)
};

const it_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta video - Seleziona cartella`)
};

const ru_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео - Выберите папку`)
};

const es_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar vídeo - Seleccionar carpeta`)
};

const zh_cn2_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出视频 - 选择文件夹`)
};

const ja_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポート - フォルダの選択`)
};

const hi_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात करें - फ़ोल्डर चुनें`)
};

const pt_pt2_video_export_select_folder_title = /** @type {(inputs: Video_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar vídeo - Selecionar pasta`)
};

/**
* | output |
* | --- |
* | "Export Video - Select Folder" |
*
* @param {Video_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_select_folder_title = /** @type {((inputs?: Video_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_select_folder_title(inputs)
	if (locale === "de") return de_video_export_select_folder_title(inputs)
	if (locale === "it") return it_video_export_select_folder_title(inputs)
	if (locale === "ru") return ru_video_export_select_folder_title(inputs)
	if (locale === "es") return es_video_export_select_folder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_select_folder_title(inputs)
	if (locale === "ja") return ja_video_export_select_folder_title(inputs)
	if (locale === "hi") return hi_video_export_select_folder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_select_folder_title(inputs)
	return en_video_export_select_folder_title(inputs)
});